import React, { useEffect, useState } from 'react';
import { Col, Input, Row, Button, Form, FormFeedback, Alert, Spinner } from 'reactstrap';

//redux
import { useSelector, useDispatch } from "react-redux";

import { Link } from "react-router-dom";
import withRouter from "../../Components/Common/withRouter";
// Formik validation
import * as Yup from "yup";
import { useFormik } from "formik";

// actions
import { loginUser, getAppsData } from "../../slices/thunks";

import { createSelector } from 'reselect';
import AuthSlider from 'pages/Authentication/Landing';


const Login = (props: any) => {
    const dispatch: any = useDispatch();


     const selectLayoutState = (state: any) => state;
  const loginpageData = createSelector(selectLayoutState, (state) => ({
    errorMsg: state.Login.errorMsg,
    user: state.Login.user,
    isUserLogout: state.Login.isUserLogout,
  }));
  const { errorMsg, user, isUserLogout } = useSelector(loginpageData);
  const [loader, setLoader] = useState<boolean>(false);
  useEffect(() => {
    if (isUserLogout) return;
    dispatch(getAppsData())
      .unwrap()
      .then((data: any) => {
        if (data?.code === "000") {
          props.router.navigate("/apps");
        }
      })
      .catch(() => {
        // Not authenticated — stay on /login.
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

    const validation: any = useFormik({
        // enableReinitialize : use this flag when initial values needs to be changed
        enableReinitialize: true,

        initialValues: {
            username: user.username,
            password: "",
        },
        validationSchema: Yup.object({
            username: Yup.string().required("Veuillez saisir votre identifiant"),
            password: Yup.string().required("Veuillez saisir votre mot de passe"),
        }),
        onSubmit: (values) => {
            dispatch(loginUser(values, props.router.navigate));
            setLoader(true)
        }
    });

    useEffect(() => {
        if (errorMsg) {
            setTimeout(() => {
                //dispatch(resetLoginFlag());
                setLoader(false)
            }, 1000);
        }
    }, [dispatch, errorMsg]);

    document.title = "Authentification | Business Online";
    return (
        <React.Fragment>
                <div className="auth-content">
                    <Row className="g-0 auth-container">
                        <Col lg={5} xs={12}>
                            <div className="auth-bloc">
                                <div>
                                    <p className='text'><span style={{color: '#0290d9'}}>Business online</span>, le portail de global Banking qui vous permet de gérer vos opérations de Cash Management et de Trade Finance en toute sécurité et efficacité.</p>
                                    <h2>AUTHENTIFICATION</h2>
                                </div>
                                {errorMsg && <Alert color="danger" transition={{ timeout: 150 }}> {errorMsg} </Alert>}
                                <div className="mt-4">
                                    <Form
                                        onSubmit={(e) => {
                                            e.preventDefault();
                                            validation.handleSubmit();
                                            return false;
                                        }}
                                        action="#">

                                        <div className="mb-3">
                                            <Input type="text" className="form-control" id="username"
                                                name="username"
                                                placeholder='Identifiant'
                                                onChange={validation.handleChange}
                                                onBlur={validation.handleBlur}
                                                value={validation.values.username || ""}
                                                invalid={
                                                    validation.touched.username && validation.errors.username ? true : false
                                                }
                                            />
                                            {validation.touched.username && validation.errors.username ? (
                                                <FormFeedback type="invalid">{validation.errors.username}</FormFeedback>
                                            ) : null}
                                        </div>

                                        <div className="mb-3">
                                            <div className="position-relative auth-pass-inputgroup mb-3">
                                                <Input 
                                                    name="password"
                                                    placeholder='Mot de passe'
                                                    value={validation.values.password || ""}
                                                    type={"password"} 
                                                    className="form-control pe-5 password-input" 
                                                    onChange={validation.handleChange}
                                                    onBlur={validation.handleBlur}
                                                    invalid={
                                                        validation.touched.password && validation.errors.password ? true : false
                                                    }
                                                />
                                                {validation.touched.password && validation.errors.password ? (
                                                    <FormFeedback type="invalid">{validation.errors.password}</FormFeedback>
                                                ) : null}
                                            </div>
                                        </div>

                                        <div className="mt-4">
                                            <Button color="success" 
                                                disabled={loader && true}
                                                className="w-100" 
                                                type="submit">
                                                {loader && <Spinner size="sm" className='me-2'> Loading... </Spinner>}
                                                SE CONNECTER
                                            </Button>
                                        </div>
                                        <hr style={{margin: '30px'}} />
                                        <div className="mt-4">
                                            <Button color="default" className="w-100" onClick={() => {window.location.href = '/demo'}}>
                                                DÉMONSTRATION CASH
                                            </Button>
                                        </div>
                                    </Form>
                                </div>

                            </div>
                        </Col>
                        <AuthSlider />
                    </Row>         
                </div>
                
                <div className="contact">
                    <Link to="/FAQ">
                        <i className='bx bx-help-circle'></i> <span>F.A.Q</span>
                    </Link>
                </div>
           
        </React.Fragment>
    );
};

export default withRouter(Login);